<template>
  <div
    class="relative w-full flex-col items-center text-white bg-[#0f0f0f] mt-[20px] pt-[20px] lg:pt-[30px] pb-[40px] lg:pb-[60px]"
  >
    <!-- Scrollable Content Wrapper -->
    <div class="w-full h-full flex flex-col items-center justify-start">
      
      <!-- Promotions Banner Section -->
      <section class="relative w-full max-w-[1300px] mx-auto px-4 pt-8 lg:pt-12">
        <div class="relative w-full h-[110px] md:h-[130px] lg:h-[140px] mb-4 lg:mb-6 overflow-hidden rounded-[20px] flex items-center shadow-xl">
          <!-- Background Image -->
          <img src="@/assets/revamp/promotion-hero-1.png" alt="Promotions Banner" class="absolute inset-0 w-full h-full object-cover object-center pointer-events-none z-0" />
          
          <!-- Text Content -->
          <div class="relative z-10 w-full pl-6 md:pl-10 lg:pl-12">
            <h1 class="text-3xl md:text-4xl lg:text-[42px] font-black tracking-wider uppercase font-sans text-white m-0 leading-[1.1] drop-shadow-md">
              {{ $t("Promotion.Promotions") || 'PROMOTIONS' }}
            </h1>
            <p class="text-[13px] sm:text-[14px] md:text-[15px] text-gray-300 mt-1 font-medium drop-shadow-sm">
              {{ $t('Promotion.Subtext') }}
            </p>
          </div>
        </div>
      </section>

      <!-- Promotions Cards Section -->
      <section id="promotions" class="relative w-full max-w-[1300px] mx-auto px-4">
        <div class="w-full flex flex-col lg:flex-row items-stretch justify-between mt-6 relative z-20 gap-6">
          
          <!-- Left Card (60%) -->
          <div 
            class="relative w-full lg:w-[60%] rounded-[20px] overflow-hidden flex flex-col justify-start p-8 md:p-12 text-white bg-21com-promo-bg bg-no-repeat bg-center min-h-[420px] shadow-lg"
            :style="{ backgroundImage: 'url(' + promotionHero2 + ')' }"
          >
            <!-- Content Container -->
            <div class="flex flex-col items-start gap-3 w-full max-w-[260px] md:max-w-[340px] lg:max-w-[400px]">
              <!-- Small Uppercase Label -->
              <span class="text-xs md:text-sm font-black tracking-widest text-[#00ffff] uppercase font-sans">
                {{ $t('Promotion.ExclusiveOffer') }}
              </span>
              
              <!-- Logo + Dot + Play With More! -->
              <div class="flex items-center gap-2 flex-wrap">
                <!-- 21.com Image Logo -->
                <img src="@/assets/revamp/21com-logo.png" alt="21.com" class="h-5 md:h-6 w-auto object-contain" />
                <!-- Dot separator -->
                <span class="w-1.5 h-1.5 rounded-full bg-white/60 self-center"></span>
                <!-- Subtitle -->
                <span class="text-white text-sm md:text-base font-medium tracking-wide">
                  {{ $t('Promotion.PlayWithMore') }}
                </span>
              </div>
              
              <!-- Headline -->
              <h2 class="text-3xl md:text-4xl lg:text-[40px] font-black tracking-wide text-[#00ffff] font-sans leading-tight mt-2">
                {{ $t('Promotion.Deposit10Play25') }}
              </h2>
              
              <!-- Promo Code -->
              <div class="text-lg md:text-xl font-extrabold text-[#c6f605] tracking-wide uppercase font-sans">
                {{ $t('Promotion.UseCode25') }}
              </div>
              
              <!-- Body Description -->
              <p class="text-white/95 text-sm md:text-base leading-relaxed max-w-lg mt-1 font-sans">
                {{ $t('Promotion.Promo1Desc') }}
              </p>

              <!-- Button -->
              <div class="mt-3">
                <a 
                  href="https://21.games/Maherco400" 
                  target="_blank" 
                  class="inline-block text-center bg-[#00e5ff] text-black font-extrabold text-[14px] px-8 py-3 rounded-xl hover:bg-[#00cce6] transition-all shadow-[0_0_20px_rgba(0,229,255,0.4)]"
                >
                  {{ $t('Promotion.ClaimBonusNow') }}
                </a>
              </div>
            </div>
          </div>
          
          <!-- Right Card (40%) -->
          <div 
            class="relative w-full lg:w-[40%] rounded-[20px] overflow-hidden flex flex-col justify-between p-6 md:p-8 text-white bg-[#151515] min-h-[420px] shadow-lg border border-white/5 group"
          >
            <!-- Banner Graphic Image (Whole Image) -->
            <div class="relative w-full flex-1 rounded-xl overflow-hidden mb-6 flex items-center justify-center bg-black/40 border border-white/10">
              <img 
                :src="banner21" 
                alt="21.com MAHERCO 400% Welcome Package" 
                class="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500 rounded-xl" 
              />
            </div>
            
            <!-- Button -->
            <div class="w-full mt-auto">
              <a 
                href="https://21.games/Maherco400" 
                target="_blank" 
                class="block w-full text-center bg-[#6b00b3] text-white font-extrabold text-[14px] px-8 py-3.5 rounded-xl border-2 border-[#a832ff] shadow-[0_0_20px_rgba(107,0,179,0.5)] hover:bg-[#590099] transition-all"
              >
                {{ $t('Promotion.ClaimBonusNow') }}
              </a>
            </div>
          </div>
          
        </div>

        <!-- Third Promotion Banner (Skin Club) -->
        <div class="w-full mt-6 relative z-20">
          <div class="relative w-full rounded-[20px] overflow-hidden flex flex-col md:flex-row items-stretch min-h-[450px] md:min-h-[550px] shadow-lg border border-white/5 bg-[#151515]">
            
            <!-- Background Ambient Glows & Pattern -->
            <div class="absolute top-[-20%] left-[-10%] w-[50%] h-[60%] bg-[#f700ff]/10 blur-[100px] rounded-full pointer-events-none z-0"></div>
            <div class="absolute bottom-[-10%] left-[20%] w-[40%] h-[50%] bg-[#00ffff]/10 blur-[100px] rounded-full pointer-events-none z-0"></div>
            <div class="absolute inset-0 z-0 opacity-[0.03] pointer-events-none" style="background-image: radial-gradient(#ffffff 1px, transparent 1px); background-size: 24px 24px;"></div>

            <!-- Left Side: Text and CTA -->
            <div class="w-full md:w-[60%] lg:w-[65%] p-8 md:p-10 lg:p-12 flex flex-col justify-center z-10">
              <div class="flex flex-col items-start gap-3 w-full max-w-[260px] md:max-w-[340px] lg:max-w-[400px]">
                <!-- Small Uppercase Label -->
                <span class="text-xs md:text-sm font-black tracking-widest text-[#00ffff] uppercase font-sans">
                  {{ $t('Promotion.ExclusiveOffer') }}
                </span>
                
                <!-- Logo image + Dot + Subtitle -->
                <div class="flex items-center gap-2 flex-wrap">
                  <img src="@/assets/revamp/skin-club-logo.png" alt="SkinClub" class="h-5 md:h-6 w-auto object-contain" />
                  <!-- Dot separator -->
                  <span class="w-1.5 h-1.5 rounded-full bg-white/60 self-center"></span>
                  <!-- Subtitle -->
                  <span class="text-white text-sm md:text-base font-medium tracking-wide">
                    {{ $t('Promotion.PlayWithMore') }}
                  </span>
                </div>
                
                <!-- Headline -->
                <h2 class="text-3xl md:text-4xl lg:text-[40px] font-black tracking-wide text-[#00ffff] font-sans leading-tight mt-2">
                  {{ $t('Promotion.SkinClubHeadline') || 'Get +7% Deposit Bonus' }}
                </h2>
                
                <!-- Promo Code -->
                <div class="text-lg md:text-xl font-extrabold text-[#c6f605] tracking-wide uppercase font-sans">
                  {{ $t('Promotion.UseCode') || 'USE CODE:' }} MAHERCO3
                </div>
                
                <!-- Body Description -->
                <p class="text-white/95 text-sm md:text-base leading-relaxed max-w-lg mt-1 font-sans">
                  {{ $t('Promotion.SkinClubDesc') || 'REGISTER NOW TO GET EXCITING REWARDS EVERYDAY!' }}
                </p>
              </div>
              
              <!-- Button -->
              <div class="mt-8">
                <a 
                  href="https://l.skin.club/126MAHERCO1ST" 
                  target="_blank" 
                  class="inline-block text-center bg-[#00e5ff] text-black font-extrabold text-[14px] px-8 py-3 rounded-xl hover:bg-[#00cce6] transition-all shadow-[0_0_20px_rgba(0,229,255,0.4)]"
                >
                  {{ $t('Promotion.RegisterOnSkinClub') || 'REGISTER ON SKIN.CLUB' }}
                </a>
              </div>
            </div>
            
            <!-- Right Side: Image -->
            <div class="w-full md:w-[40%] lg:w-[35%] relative min-h-[250px] md:min-h-full flex items-end justify-center md:justify-end overflow-hidden">
              <img 
                :src="$i18n.locale === 'ar' ? skinClubArabic : skinClubEnglish" 
                alt="Skin Club Promotion" 
                class="w-full h-auto max-h-[110%] object-contain object-bottom pt-4 md:pt-0 transform md:scale-110 md:origin-bottom"
              />
            </div>
            
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import promotionHero2 from "@/assets/revamp/promotion-hero-2.png";
import skinClubEnglish from "@/assets/revamp/skin-club-english-promotion.webp";
import skinClubArabic from "@/assets/revamp/skin-club-arabic-promotion.webp";
import banner21 from "@/assets/revamp/21-banner.webp";

export default defineComponent({
  name: "PromotionPage",
  data() {
    return {
      promotionHero2,
      skinClubEnglish,
      skinClubArabic,
      banner21,
    };
  },
});
</script>